import { Switch } from '@/global/components/Switch'
import { CategoriaEnum } from '@acme/auth'
import React from 'react'
import { EntradaSaidaManutencaoProps } from './types'

const SaidaDiaAnterior: React.FC<EntradaSaidaManutencaoProps> = ({
    categoria,
    saidaDiaAnterior,
    entradaDiaSeguinte,
    isLoading,
    toggle,
}) => {
    if (categoria === CategoriaEnum.Funcionario) return null

    return (
        <Switch
            label="Saída no dia anterior"
            checked={saidaDiaAnterior === 'S'}
            disabled={entradaDiaSeguinte === 'S' || isLoading}
            onChange={() => toggle('saida-dia-anterior')}
        />
    )
}

export default SaidaDiaAnterior
